/**
 * This is the state machine for the linter UI.
 * It is responsible for handling the state transitions and events.
 */
// Copyright Jon Verrier, 2025

export enum EUIState {
   Waiting = 'Waiting',
   Checking = 'Checking',
   Linting = 'Linting',
   NotARequirement = 'NotARequirement',
   Error = 'Error'
}

export enum EApiEvent {
   StartedCheck = 'StartedCheck',
   StartedLint = 'StartedLint',
   RejectedCheck = 'RejectedCheck',
   PassedCheck = 'PassedCheck',
   Linted = 'Linted',
   Error = 'Error',
   Reset = 'Reset'
}

export class LinterUIStateMachine {
   private state: EUIState;

   constructor(initialState: EUIState) {
      this.state = initialState;
   }

   public transition(event: EApiEvent): void {
      switch (this.state) {
         case EUIState.Waiting:
            if (event === EApiEvent.StartedCheck) {
               this.state = EUIState.Checking;
            }
            else if (event === EApiEvent.Reset) {
               this.state = EUIState.Waiting;
            }
            else {
               throw new Error(`Invalid state change: Cannot transition from ${this.state} with event ${event}`);
            }
            break;
         case EUIState.Checking:
            if (event === EApiEvent.PassedCheck) {
               this.state = EUIState.Linting;
            }
            else
            if (event === EApiEvent.RejectedCheck) {
               this.state = EUIState.NotARequirement;
            }
            else
            if (event === EApiEvent.Error) {
               this.state = EUIState.Error;
            }
            else {
               throw new Error(`Invalid state change: Cannot transition from ${this.state} with event ${event}`);
            }
            break;
         case EUIState.Linting:
            if (event === EApiEvent.Linted) {
               this.state = EUIState.Waiting;
            }
            else
            if (event === EApiEvent.Error) {
               this.state = EUIState.Error;
            }
            else
            if (event === EApiEvent.StartedLint) {
               // This is a no-op - we actually go to Linting after PassedCheck
               this.state = EUIState.Linting;
            }
            else {
               throw new Error(`Invalid state change: Cannot transition from ${this.state} with event ${event}`);
            }
            break;
         case EUIState.NotARequirement:
            if (event === EApiEvent.Reset) {
               this.state = EUIState.Waiting;
            }
            else
            if (event === EApiEvent.Error) {
               this.state = EUIState.Error;
            }
            else {
               throw new Error(`Invalid state change: Cannot transition from ${this.state} with event ${event}`);
            }
            break;
         case EUIState.Error:
            if (event === EApiEvent.Reset) {
               this.state = EUIState.Waiting;
            }
            else {
               throw new Error(`Invalid state change: Cannot transition from ${this.state} with event ${event}`);
            }
            break;
         default:
            throw new Error(`Unknown state: ${this.state}`);
      }
   }

   public getState(): EUIState {
      return this.state;
   }
}
